import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function DnDAddSidebarSettingsImage_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else DnDAddSidebarSettingsImage_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const DnDAddSidebarSettingsImage = (props)=>{
    const $ = c(38);
    let t0;
    let t1;
    let t10;
    let t11;
    let t12;
    let t13;
    let t14;
    let t15;
    let t16;
    let t17;
    let t18;
    let t19;
    let t2;
    let t20;
    let t21;
    let t22;
    let t23;
    let t24;
    let t25;
    let t26;
    let t27;
    let t28;
    let t29;
    let t3;
    let t30;
    let t31;
    let t32;
    let t33;
    let t34;
    let t35;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ jsx("path", {
            d: "M31.8715 82.2405C32.2054 82.295 32.5486 82.3233 32.8992 82.3233V83.2197L32.7135 83.2173C32.3779 83.2089 32.0482 83.1767 31.7256 83.124L31.8715 82.2405ZM34.2193 82.3233V83.2197H32.8992V82.3233H34.2193ZM38.4445 82.3233V83.2197H35.8037V82.3233H38.4445ZM42.6691 82.3233V83.2197H40.0289V82.3233H42.6691ZM46.8937 82.3233V83.2197H44.2535V82.3233H46.8937ZM51.1189 82.3233V83.2197H48.4781V82.3233H51.1189ZM55.3436 82.3233V83.2197H52.7033V82.3233H55.3436ZM59.5687 82.3233V83.2197H56.9279V82.3233H59.5687ZM63.7934 82.3233V83.2197H61.1531V82.3233H63.7934ZM68.0186 82.3233V83.2197H65.3777V82.3233H68.0186ZM72.2432 82.3233V83.2197H69.6023V82.3233H72.2432ZM76.4678 82.3233V83.2197H73.8275V82.3233H76.4678ZM79.3723 82.3233V83.2197H78.0521V82.3233H79.3723ZM80.5453 83.124C80.223 83.1766 79.8937 83.2089 79.5586 83.2173L79.3723 83.2197V82.3233C79.7229 82.3233 80.0667 82.295 80.4006 82.2405L80.5453 83.124ZM83.9396 81.5916C83.3368 82.0848 82.652 82.4817 81.9088 82.7604L81.5924 81.923C82.242 81.6794 82.841 81.3314 83.3689 80.8995L83.9396 81.5916ZM28.9031 80.8995C29.431 81.3314 30.0302 81.6794 30.6797 81.923L30.4658 82.4873L30.3621 82.7598C29.619 82.481 28.934 82.0848 28.3312 81.5916L28.9031 80.8995ZM27.0012 78.2594C27.2458 78.9064 27.5952 79.503 28.0289 80.0288L27.6803 80.313L27.6809 80.3136L27.3334 80.5972C26.8382 79.9968 26.4396 79.3148 26.1598 78.5746L27.0012 78.2594ZM86.1117 78.5746C85.8319 79.3148 85.4334 79.9968 84.9381 80.5972L84.5906 80.3136L84.2432 80.0288C84.6769 79.5031 85.0263 78.9063 85.2709 78.2594L86.1117 78.5746ZM25.6992 76.0489V74.7955H26.5992V76.0489C26.5992 76.3981 26.6277 76.74 26.6824 77.0725L25.7947 77.2166C25.7419 76.8957 25.7101 76.5677 25.7016 76.2339L25.6992 76.0489ZM86.5699 76.2339C86.5614 76.5677 86.5295 76.8957 86.4768 77.2166L85.5891 77.0725C85.6438 76.74 85.6728 76.3981 85.6728 76.0489V74.7955H86.5728V76.0489L86.5699 76.2339ZM26.5992 70.7847V73.2911H25.6992V70.7847H26.5992ZM86.5728 70.7847V73.2911H85.6728V70.7847H86.5728ZM26.5992 66.7739V69.2803H25.6992V66.7739H26.5992ZM86.5728 66.7739V69.2803H85.6728V66.7739H86.5728ZM26.5992 62.7625V65.2695H25.6992V62.7625H26.5992ZM86.5728 62.7625V65.2695H85.6728V62.7625H86.5728ZM26.5992 58.7518V61.2587H25.6992V58.7518H26.5992ZM86.5728 58.7518V61.2587H85.6728V58.7518H86.5728ZM26.5992 54.741V57.2479H25.6992V54.741H26.5992ZM86.5728 54.741V57.2479H85.6728V54.741H86.5728ZM26.5992 50.7302V53.2372H25.6992V50.7302H26.5992ZM86.5728 50.7302V53.2372H85.6728V50.7302H86.5728ZM26.5992 46.7194V49.2264H25.6992V46.7194H26.5992ZM86.5728 46.7194V49.2264H85.6728V46.7194H86.5728ZM86.5728 42.7087V45.2156H85.6728V42.7087H86.5728ZM26.5992 42.7087V45.215H25.6992V42.7087H26.5992ZM26.5992 38.6979V41.2042H25.6992V38.6979H26.5992ZM86.5728 38.6979V41.2042H85.6728V38.6979H86.5728ZM26.5992 34.6871V37.1935H25.6992V34.6871H26.5992ZM86.5728 34.6871V37.1935H85.6728V34.6871H86.5728ZM26.5992 30.6757V33.1827H25.6992V30.6757H26.5992ZM86.5728 30.6757V33.1827H85.6728V30.6757H86.5728ZM26.5992 26.665V29.1719H25.6992V26.665H26.5992ZM86.5728 26.665V29.1719H85.6728V26.665H86.5728ZM25.6992 23.9077C25.6992 23.5096 25.7321 23.1192 25.7947 22.7388L26.6824 22.8841C26.6277 23.2166 26.5992 23.5585 26.5992 23.9077V25.1611H25.6992V23.9077ZM86.5728 25.1611H85.6728V23.9077C85.6728 23.5585 85.6438 23.2167 85.5891 22.8841L86.4768 22.7388C86.5394 23.1192 86.5728 23.5096 86.5728 23.9077V25.1611ZM28.0289 19.9278C27.5952 20.4536 27.2458 21.0502 27.0012 21.6972L26.5799 21.5384L26.1604 21.3809C26.4402 20.6408 26.8382 19.9585 27.3334 19.3583L28.0289 19.9278ZM84.9381 19.3583C85.4333 19.9585 85.8312 20.6408 86.1111 21.3809L85.2709 21.6972C85.0263 21.0503 84.6768 20.4535 84.2432 19.9278L84.9381 19.3583ZM30.6797 18.0336C30.0301 18.2772 29.431 18.6252 28.9031 19.0571L28.3312 18.3645C28.934 17.8713 29.6191 17.4749 30.3621 17.1962L30.6797 18.0336ZM81.9088 17.1956C82.652 17.4743 83.3368 17.8712 83.9396 18.3645L83.3689 19.0571C82.841 18.6252 82.2419 18.2772 81.5924 18.0336L81.9088 17.1956ZM34.2193 16.7369V17.6333H32.8992C32.5486 17.6333 32.2054 17.6616 31.8715 17.7161L31.7256 16.832C32.1075 16.7697 32.4995 16.7369 32.8992 16.7369H34.2193ZM79.3723 16.7369C79.7716 16.7369 80.1636 16.7698 80.5453 16.832L80.4006 17.7161C80.0667 17.6616 79.7229 17.6333 79.3723 17.6333H78.0521V16.7369H79.3723ZM38.4445 16.7369V17.6333H35.8037V16.7369H38.4445ZM42.6691 16.7369V17.6333H40.0289V16.7369H42.6691ZM46.8937 16.7369V17.6333H44.2535V16.7369H46.8937ZM51.1189 16.7369V17.6333H48.4781V16.7369H51.1189ZM55.3436 16.7369V17.6333H52.7033V16.7369H55.3436ZM59.5687 16.7369V17.6333H56.9279V16.7369H59.5687ZM63.7934 16.7369V17.6333H61.1531V16.7369H63.7934ZM68.0186 16.7369V17.6333H65.3777V16.7369H68.0186ZM72.2432 16.7369V17.6333H69.6023V16.7369H72.2432ZM76.4678 16.7369V17.6333H73.8275V16.7369H76.4678Z",
            fill: "#E2E6EB"
        });
        t1 = /*#__PURE__*/ jsx("path", {
            d: "M32.0068 25.1839C32.0068 23.8566 33.0873 22.7805 34.42 22.7805H78.349C79.6818 22.7805 80.7622 23.8566 80.7622 25.1839V34.4795C80.7622 35.8069 79.6818 36.8829 78.349 36.8829H34.42C33.0873 36.8829 32.0068 35.8069 32.0068 34.4795V25.1839Z",
            fill: "#FAFAFA"
        });
        t2 = /*#__PURE__*/ jsx("path", {
            d: "M32.0068 25.1839C32.0068 23.8566 33.0873 22.7805 34.42 22.7805H78.349C79.6818 22.7805 80.7622 23.8566 80.7622 25.1839V34.4795C80.7622 35.8069 79.6818 36.8829 78.349 36.8829H34.42C33.0873 36.8829 32.0068 35.8069 32.0068 34.4795V25.1839Z",
            fill: "#FAFAFA"
        });
        t3 = /*#__PURE__*/ jsx("path", {
            d: "M80.7622 34.4795C80.7622 35.8069 79.6818 36.8829 78.349 36.8829H34.42C33.0873 36.8829 32.0068 35.8069 32.0068 34.4795L32.0098 34.5824C32.0743 35.6408 33.1291 36.4824 34.4203 36.4824H78.3492C79.6818 36.4823 80.7621 35.5856 80.7622 34.4795Z",
            fill: "#E2E6EB"
        });
        t4 = /*#__PURE__*/ jsx("path", {
            d: "M48.2585 26.6038C48.2585 26.1614 48.6186 25.8027 49.0629 25.8027H70.2066C70.6509 25.8027 71.011 26.1614 71.011 26.6038V27.0162C71.011 27.4586 70.6509 27.8173 70.2066 27.8173H49.0629C48.6186 27.8173 48.2585 27.4586 48.2585 27.0162V26.6038Z",
            fill: "#E2E6EB"
        });
        t5 = /*#__PURE__*/ jsx("path", {
            d: "M71.011 27.0162C71.011 27.4586 70.6509 27.8173 70.2066 27.8173H49.0629C48.6186 27.8173 48.2585 27.4586 48.2585 27.0162C48.2585 27.348 48.6187 27.617 49.063 27.617H70.2065C70.6508 27.617 71.011 27.348 71.011 27.0162Z",
            fill: "#818C99"
        });
        t6 = /*#__PURE__*/ jsx("path", {
            d: "M48.2585 30.633C48.2585 30.1906 48.6186 29.8319 49.0629 29.8319H59.3721C59.8163 29.8319 60.1765 30.1906 60.1765 30.633V31.0454C60.1765 31.4879 59.8163 31.8465 59.3721 31.8465H49.0629C48.6186 31.8465 48.2585 31.4879 48.2585 31.0454V30.633Z",
            fill: "#E2E6EB"
        });
        t7 = /*#__PURE__*/ jsx("path", {
            d: "M60.1765 31.0454C60.1765 31.4879 59.8163 31.8465 59.3721 31.8465H49.0629C48.6186 31.8465 48.2585 31.4879 48.2585 31.0454C48.2585 31.3773 48.6187 31.6462 49.063 31.6462H59.3719C59.8162 31.6462 60.1765 31.3773 60.1765 31.0454Z",
            fill: "#818C99"
        });
        t8 = /*#__PURE__*/ jsx("path", {
            d: "M34.1738 26.3856C34.1738 25.5007 34.8941 24.7833 35.7826 24.7833H42.765C43.6535 24.7833 44.3738 25.5007 44.3738 26.3856V33.3396C44.3738 34.2245 43.6535 34.9419 42.765 34.9419H35.7826C34.8941 34.9419 34.1738 34.2245 34.1738 33.3396V26.3856Z",
            fill: "#D8E5FF"
        });
        t9 = /*#__PURE__*/ jsx("path", {
            d: "M44.3738 33.3396C44.3738 34.2245 43.6535 34.9419 42.765 34.9419H35.7826C34.8941 34.9419 34.1738 34.2245 34.1738 33.3396C34.1738 34.0067 34.8943 34.5474 35.7828 34.5474H42.7648C43.6533 34.5474 44.3738 34.0067 44.3738 33.3396Z",
            fill: "#99BCFF"
        });
        t10 = /*#__PURE__*/ jsx("path", {
            d: "M32.0069 45.2389C32.0069 43.9115 33.0873 42.8355 34.4201 42.8355H78.3491C79.6819 42.8355 80.7623 43.9115 80.7623 45.2389V54.5345C80.7623 55.8618 79.6819 56.9379 78.3491 56.9379H34.4201C33.0873 56.9379 32.0069 55.8618 32.0069 54.5345V45.2389Z",
            fill: "white"
        });
        t11 = /*#__PURE__*/ jsx("path", {
            d: "M80.7623 54.5345C80.7623 55.8618 79.6819 56.9379 78.3491 56.9379H34.4201C33.0873 56.9379 32.0069 55.8618 32.0069 54.5345L32.0098 54.6373C32.0743 55.6957 33.1292 56.5374 34.4204 56.5374H78.3493C79.6819 56.5373 80.7622 55.6405 80.7623 54.5345Z",
            fill: "#E2E6EB"
        });
        t12 = /*#__PURE__*/ jsx("path", {
            d: "M32.0069 45.2389C32.0069 43.9115 33.0873 42.8355 34.4201 42.8355H78.3491C79.6819 42.8355 80.7623 43.9115 80.7623 45.2389V54.5345C80.7623 55.8618 79.6819 56.9379 78.3491 56.9379H34.4201C33.0873 56.9379 32.0069 55.8618 32.0069 54.5345V45.2389Z",
            fill: "white"
        });
        t13 = /*#__PURE__*/ jsx("path", {
            d: "M80.7623 54.5345C80.7623 55.8618 79.6819 56.9379 78.3491 56.9379H34.4201C33.0873 56.9379 32.0069 55.8618 32.0069 54.5345L32.0098 54.6373C32.0743 55.6957 33.1292 56.5374 34.4204 56.5374H78.3493C79.6819 56.5373 80.7622 55.6405 80.7623 54.5345Z",
            fill: "#E2E6EB"
        });
        t14 = /*#__PURE__*/ jsx("path", {
            d: "M48.2585 46.6589C48.2585 46.2164 48.6186 45.8578 49.0629 45.8578H70.2066C70.6509 45.8578 71.011 46.2164 71.011 46.6589V47.0713C71.011 47.5137 70.6509 47.8724 70.2066 47.8724H49.0629C48.6186 47.8724 48.2585 47.5137 48.2585 47.0713V46.6589Z",
            fill: "#E2E6EB"
        });
        t15 = /*#__PURE__*/ jsx("path", {
            d: "M71.011 47.0713C71.011 47.5137 70.6509 47.8724 70.2066 47.8724H49.0629C48.6186 47.8724 48.2585 47.5137 48.2585 47.0713C48.2585 47.4031 48.6187 47.672 49.063 47.672H70.2065C70.6508 47.672 71.011 47.4031 71.011 47.0713Z",
            fill: "#818C99"
        });
        t16 = /*#__PURE__*/ jsx("path", {
            d: "M48.2585 50.6881C48.2585 50.2457 48.6186 49.887 49.0629 49.887H59.3721C59.8163 49.887 60.1765 50.2457 60.1765 50.6881V51.1005C60.1765 51.5429 59.8163 51.9016 59.3721 51.9016H49.0629C48.6186 51.9016 48.2585 51.5429 48.2585 51.1005V50.6881Z",
            fill: "#E2E6EB"
        });
        t17 = /*#__PURE__*/ jsx("path", {
            d: "M60.1765 51.1005C60.1765 51.5429 59.8163 51.9016 59.3721 51.9016H49.0629C48.6186 51.9016 48.2585 51.5429 48.2585 51.1005C48.2585 51.4323 48.6187 51.7012 49.063 51.7012H59.372C59.8162 51.7012 60.1765 51.4323 60.1765 51.1005Z",
            fill: "#818C99"
        });
        t18 = /*#__PURE__*/ jsx("path", {
            d: "M34.1738 46.7029C34.1738 45.818 34.8941 45.1006 35.7826 45.1006H42.765C43.6535 45.1006 44.3738 45.818 44.3738 46.7029V53.6569C44.3738 54.5418 43.6535 55.2592 42.765 55.2592H35.7826C34.8941 55.2592 34.1738 54.5418 34.1738 53.6569V46.7029Z",
            fill: "#D8E5FF"
        });
        t19 = /*#__PURE__*/ jsx("path", {
            d: "M44.3738 53.6569C44.3738 54.5418 43.6535 55.2592 42.765 55.2592H35.7826C34.8941 55.2592 34.1738 54.5418 34.1738 53.6569C34.1738 54.324 34.8943 54.8647 35.7828 54.8647H42.7648C43.6533 54.8647 44.3738 54.324 44.3738 53.6569Z",
            fill: "#99BCFF"
        });
        t20 = /*#__PURE__*/ jsx("path", {
            d: "M32.0068 65.8794C32.0068 64.5521 33.0873 63.476 34.42 63.476H78.349C79.6818 63.476 80.7622 64.5521 80.7622 65.8794V75.175C80.7622 76.5024 79.6818 77.5784 78.349 77.5784H34.42C33.0873 77.5784 32.0068 76.5024 32.0068 75.175V65.8794Z",
            fill: "white"
        });
        t21 = /*#__PURE__*/ jsx("path", {
            d: "M80.7622 75.175C80.7622 76.5024 79.6818 77.5784 78.349 77.5784H34.42C33.0873 77.5784 32.0068 76.5024 32.0068 75.175L32.0098 75.2779C32.0743 76.3362 33.1291 77.1779 34.4203 77.1779H78.3492C79.6818 77.1778 80.7621 76.281 80.7622 75.175Z",
            fill: "#E2E6EB"
        });
        t22 = /*#__PURE__*/ jsx("path", {
            d: "M32.0068 65.8794C32.0068 64.5521 33.0873 63.476 34.42 63.476H78.349C79.6818 63.476 80.7622 64.5521 80.7622 65.8794V75.175C80.7622 76.5024 79.6818 77.5784 78.349 77.5784H34.42C33.0873 77.5784 32.0068 76.5024 32.0068 75.175V65.8794Z",
            fill: "white"
        });
        t23 = /*#__PURE__*/ jsx("path", {
            d: "M80.7622 75.175C80.7622 76.5024 79.6818 77.5784 78.349 77.5784H34.42C33.0873 77.5784 32.0068 76.5024 32.0068 75.175L32.0098 75.2779C32.0743 76.3362 33.1291 77.1779 34.4203 77.1779H78.3492C79.6818 77.1778 80.7621 76.281 80.7622 75.175Z",
            fill: "#E2E6EB"
        });
        t24 = /*#__PURE__*/ jsx("path", {
            d: "M48.2585 67.2995C48.2585 66.8571 48.6186 66.4984 49.0629 66.4984H70.2066C70.6509 66.4984 71.011 66.8571 71.011 67.2995V67.7119C71.011 68.1543 70.6509 68.513 70.2066 68.513H49.0629C48.6186 68.513 48.2585 68.1543 48.2585 67.7119V67.2995Z",
            fill: "#E2E6EB"
        });
        t25 = /*#__PURE__*/ jsx("path", {
            d: "M71.011 67.7119C71.011 68.1543 70.6509 68.513 70.2066 68.513H49.0629C48.6186 68.513 48.2585 68.1543 48.2585 67.7119C48.2585 68.0437 48.6187 68.3126 49.063 68.3126H70.2065C70.6508 68.3126 71.011 68.0437 71.011 67.7119Z",
            fill: "#818C99"
        });
        t26 = /*#__PURE__*/ jsx("path", {
            d: "M48.2585 71.3287C48.2585 70.8863 48.6186 70.5276 49.0629 70.5276H59.3721C59.8163 70.5276 60.1765 70.8863 60.1765 71.3287V71.7411C60.1765 72.1835 59.8163 72.5422 59.3721 72.5422H49.0629C48.6186 72.5422 48.2585 72.1835 48.2585 71.7411V71.3287Z",
            fill: "#E2E6EB"
        });
        t27 = /*#__PURE__*/ jsx("path", {
            d: "M60.1765 71.7411C60.1765 72.1835 59.8163 72.5422 59.3721 72.5422H49.0629C48.6186 72.5422 48.2585 72.1835 48.2585 71.7411C48.2585 72.0729 48.6187 72.3419 49.063 72.3419H59.372C59.8162 72.3419 60.1765 72.0729 60.1765 71.7411Z",
            fill: "#818C99"
        });
        t28 = /*#__PURE__*/ jsx("path", {
            d: "M34.1738 67.0198C34.1738 66.1349 34.8941 65.4176 35.7826 65.4176H42.765C43.6535 65.4176 44.3738 66.1349 44.3738 67.0198V73.9738C44.3738 74.8587 43.6535 75.5761 42.765 75.5761H35.7826C34.8941 75.5761 34.1738 74.8587 34.1738 73.9738V67.0198Z",
            fill: "#D8E5FF"
        });
        t29 = /*#__PURE__*/ jsx("path", {
            d: "M44.3738 73.9738C44.3738 74.8587 43.6535 75.5761 42.765 75.5761H35.7826C34.8941 75.5761 34.1738 74.8587 34.1738 73.9738C34.1738 74.6409 34.8943 75.1816 35.7828 75.1816H42.7648C43.6533 75.1816 44.3738 74.6409 44.3738 73.9738Z",
            fill: "#99BCFF"
        });
        t30 = /*#__PURE__*/ jsx("path", {
            d: "M78.5607 24.5613C78.5607 28.5216 81.7843 31.732 85.7607 31.732H92.3607C96.3372 31.732 99.5607 28.5216 99.5607 24.5613V17.9881C99.5607 14.0278 96.3372 10.8174 92.3607 10.8174L85.7607 10.8174C81.7843 10.8174 78.5607 14.0278 78.5607 17.9881V24.5613Z",
            fill: "white"
        });
        t31 = /*#__PURE__*/ jsx("path", {
            d: "M92.3607 11.4149V10.8174L85.7607 10.8174V11.4149L92.3607 11.4149ZM98.9607 17.9881V24.5613C98.9607 28.1915 96.0058 31.1345 92.3607 31.1345H85.7607C82.1157 31.1345 79.1607 28.1915 79.1607 24.5613V17.9881C79.1607 14.3579 82.1157 11.4149 85.7607 11.4149V10.8174L85.575 10.8197C81.7461 10.9163 78.66 13.9898 78.5631 17.8031L78.5607 17.9881V24.5613C78.5607 28.5216 81.7843 31.732 85.7607 31.732H92.3607L92.5465 31.7297C96.4371 31.6316 99.5607 28.4597 99.5607 24.5613V17.9881L99.5584 17.8031C99.4614 13.9898 96.3754 10.9163 92.5465 10.8197L92.3607 10.8174V11.4149C96.0058 11.4149 98.9607 14.3579 98.9607 17.9881Z",
            fill: "#E2E6EB"
        });
        t32 = /*#__PURE__*/ jsx("path", {
            d: "M82.7607 21.1794C82.7607 20.737 83.1209 20.3783 83.5651 20.3783H94.5564C95.0006 20.3783 95.3607 20.737 95.3607 21.1794V21.3699C95.3607 21.8123 95.0006 22.171 94.5564 22.171H83.5651C83.1209 22.171 82.7607 21.8123 82.7607 21.3699V21.1794Z",
            fill: "#E2E6EB"
        });
        t33 = /*#__PURE__*/ jsx("path", {
            d: "M95.3607 21.3699C95.3607 21.8123 95.0006 22.171 94.5564 22.171H83.5651C83.1209 22.171 82.7607 21.8123 82.7607 21.3699C82.7607 21.7017 83.121 21.9708 83.5652 21.9708H94.5563C95.0005 21.9708 95.3607 21.7017 95.3607 21.3699Z",
            fill: "#818C99"
        });
        t34 = /*#__PURE__*/ jsx("path", {
            d: "M88.9651 27.549C88.5209 27.549 88.1607 27.1903 88.1607 26.7479V15.8014C88.1607 15.3589 88.5209 15.0002 88.9651 15.0002H89.1564C89.6006 15.0002 89.9607 15.3589 89.9607 15.8014V26.7479C89.9607 27.1903 89.6006 27.549 89.1564 27.549H88.9651Z",
            fill: "#E2E6EB"
        });
        t35 = /*#__PURE__*/ jsx("path", {
            d: "M88.1607 26.7479C88.1607 27.0797 88.521 27.3489 88.9652 27.3489H89.1563C89.5729 27.3489 89.9156 27.1122 89.9566 26.8091L89.9607 26.7479C89.9607 27.1903 89.6006 27.549 89.1564 27.549H88.9651C88.5487 27.549 88.2062 27.2339 88.1648 26.8301L88.1607 26.7479Z",
            fill: "#818C99"
        });
        $[0] = t0;
        $[1] = t1;
        $[2] = t10;
        $[3] = t11;
        $[4] = t12;
        $[5] = t13;
        $[6] = t14;
        $[7] = t15;
        $[8] = t16;
        $[9] = t17;
        $[10] = t18;
        $[11] = t19;
        $[12] = t2;
        $[13] = t20;
        $[14] = t21;
        $[15] = t22;
        $[16] = t23;
        $[17] = t24;
        $[18] = t25;
        $[19] = t26;
        $[20] = t27;
        $[21] = t28;
        $[22] = t29;
        $[23] = t3;
        $[24] = t30;
        $[25] = t31;
        $[26] = t32;
        $[27] = t33;
        $[28] = t34;
        $[29] = t35;
        $[30] = t4;
        $[31] = t5;
        $[32] = t6;
        $[33] = t7;
        $[34] = t8;
        $[35] = t9;
    } else {
        t0 = $[0];
        t1 = $[1];
        t10 = $[2];
        t11 = $[3];
        t12 = $[4];
        t13 = $[5];
        t14 = $[6];
        t15 = $[7];
        t16 = $[8];
        t17 = $[9];
        t18 = $[10];
        t19 = $[11];
        t2 = $[12];
        t20 = $[13];
        t21 = $[14];
        t22 = $[15];
        t23 = $[16];
        t24 = $[17];
        t25 = $[18];
        t26 = $[19];
        t27 = $[20];
        t28 = $[21];
        t29 = $[22];
        t3 = $[23];
        t30 = $[24];
        t31 = $[25];
        t32 = $[26];
        t33 = $[27];
        t34 = $[28];
        t35 = $[29];
        t4 = $[30];
        t5 = $[31];
        t6 = $[32];
        t7 = $[33];
        t8 = $[34];
        t9 = $[35];
    }
    let t36;
    if ($[36] !== props) {
        t36 = /*#__PURE__*/ jsxs("svg", _object_spread_props(_object_spread({}, props), {
            viewBox: "0 0 120 98",
            width: "120",
            height: "98",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                t0,
                t1,
                t2,
                t3,
                t4,
                t5,
                t6,
                t7,
                t8,
                t9,
                t10,
                t11,
                t12,
                t13,
                t14,
                t15,
                t16,
                t17,
                t18,
                t19,
                t20,
                t21,
                t22,
                t23,
                t24,
                t25,
                t26,
                t27,
                t28,
                t29,
                t30,
                t31,
                t32,
                t33,
                t34,
                t35
            ]
        }));
        $[36] = props;
        $[37] = t36;
    } else t36 = $[37];
    return t36;
};
export { DnDAddSidebarSettingsImage };
